<template>
    <!-- Banner sempre visibile in cima quando la licenza non è attiva, o quando è attiva
         ma l'abbonamento sta per scadere -->
    <v-banner v-if="mostraBanner" class="licenza-banner" :color="bannerColore" :icon="bannerIcona" lines="one" sticky>
        <template #text>
            <span class="text-body-2 font-weight-medium">{{ bannerTesto }}</span>
        </template>
        <template #actions>
            <v-btn v-if="licenzaStato === 0 && emailConfirmata" size="small" variant="tonal" color="white"
                href="mailto:assistenza@rilievimisure.it">
                Contatta il supporto
            </v-btn>
            <v-btn v-if="!emailConfirmata" size="small" variant="tonal" color="white"
                href="mailto:assistenza@rilievimisure.it?subject=Richiesta nuova email di conferma">
                Non hai ricevuto l'email? Contattaci
            </v-btn>
            <v-btn v-if="mostraScadenza" size="small" variant="tonal" color="white"
                :to="{ name: 'profilo', params: { tab: 'licenza' } }">
                Vai al rinnovo
            </v-btn>
        </template>
    </v-banner>
</template>

<script>
import { computed } from 'vue'

export default {
    name: 'LicenzaBanner',

    props: {
        licenzaStato: {
            type: Number,
            default: 0   // 0=attesa, 1=attiva, -1=sospesa
        },
        emailConfirmata: {
            type: Boolean,
            default: false
        },
        // Giorni rimanenti alla scadenza dell'abbonamento (null se non applicabile/sconosciuto)
        giorniAllaScadenzaAbbonamento: {
            type: Number,
            default: null
        }
    },

    setup(props) {
        const mostraScadenza = computed(() =>
            props.licenzaStato === 1 &&
            props.giorniAllaScadenzaAbbonamento !== null &&
            props.giorniAllaScadenzaAbbonamento <= 30
        )

        const mostraBanner = computed(() => props.licenzaStato !== 1 || mostraScadenza.value)

        const bannerColore = computed(() => {
            if (props.licenzaStato === -1) return 'error'
            if (mostraScadenza.value) return props.giorniAllaScadenzaAbbonamento <= 7 ? 'error' : 'warning'
            if (!props.emailConfirmata) return 'warning'
            return 'info'
        })

        const bannerIcona = computed(() => {
            if (props.licenzaStato === -1) return 'mdi-cancel'
            if (mostraScadenza.value) return 'mdi-alarm'
            if (!props.emailConfirmata) return 'mdi-email-alert-outline'
            return 'mdi-clock-outline'
        })

        const bannerTesto = computed(() => {
            if (props.licenzaStato === -1)
                return 'Il tuo account è stato sospeso. Contatta il supporto per maggiori informazioni.'
            if (mostraScadenza.value) {
                const g = props.giorniAllaScadenzaAbbonamento
                if (g < 0) return `Il tuo abbonamento è scaduto da ${Math.abs(g)} giorni. Rinnova per non perdere l'accesso.`
                if (g === 0) return 'Il tuo abbonamento scade oggi. Rinnova per non perdere l\'accesso.'
                return `Il tuo abbonamento scade tra ${g} giorni. Rinnova per continuare a usare il gestionale senza interruzioni.`
            }
            if (!props.emailConfirmata)
                return 'Conferma il tuo indirizzo email per completare la registrazione. Controlla la tua casella di posta.'
            return 'Account in attesa di attivazione. Il nostro team verificherà la tua richiesta a breve.'
        })

        return { mostraBanner, mostraScadenza, bannerColore, bannerIcona, bannerTesto }
    }
}
</script>

<style scoped>
.licenza-banner {
    z-index: 100;
}
</style>